import React, { Component } from 'react';
import './testEnvBanner.css';

// QA-only environment indicator. Rendered inside DefiLayout (like AppBanner) so every
// shell using the layout shows it, rather than each app wiring up its own copy.
//
// Environment detection is host-based, which is brittle: it only recognizes a '.qa.'
// host and silently shows nothing for any other test-environment naming. Driving this
// off a server-provided flag (as EnableUserDisplayDensity is) would be the better
// long-term shape.
function isQaEnvironment() {
  return window.location.host.indexOf('.qa.') !== -1;
}
const BODY_CLASS = 'has-test-env-banner';
class TestEnvironmentBanner extends Component {
  componentDidMount() {
    if (isQaEnvironment()) {
      document.body.classList.add(BODY_CLASS);
    }
  }
  componentWillUnmount() {
    document.body.classList.remove(BODY_CLASS);
  }
  render() {
    if (!isQaEnvironment()) return null;
    return /*#__PURE__*/React.createElement("div", {
      id: "testEnv",
      "data-testid": "test-env-banner"
    }, /*#__PURE__*/React.createElement("span", null, "TEST ENVIRONMENT"));
  }
}
export default TestEnvironmentBanner;